import type { Legislation } from "../models";
import { apiInstance } from "../utils/_apiInstance";

interface Response {
  success: boolean;
  results: Legislation[];
}

export const getLegislationById = async (id: string) => {
  const response = await apiInstance.get<Response>(`pesquisa/legislacao/${id}`);
  return response.data.results[0];
};
